// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3AdlR","imageUploader":"EGiftCard_imageUploader__tpdp2"};